<template>
<div>
            <b-container v-if="dataReset">
               <b-row v-if="newUserFormGroup"><b-col>
                          <h6>Group Title Name</h6>
                          <b-form-input type="text" v-model="newGroupName" placeholder="Give The Form Group A Name" /></b-col>
                          <b-col>
                            <h6>Button Label</h6>
                            <b-form-input type="text" v-model="newGroupBtnName" placeholder="Button Name" /></b-col>
                        <b-col>
                          <h6>Group Color Variant</h6>
                          <b-form-select v-model="newGroupVariant" :options="formGroupColorOptions" /></b-col></b-row>
                    <b-row v-if="newUserFormGroup" class="mt-2">
                    <b-col align="right" >
                      <b-btn size="sm" class="float-right" :disabled="!newGroupName || !newGroupBtnName || !newGroupVariant" variant="outline-success" @click="buildNewFormGroup">Save</b-btn></b-col></b-row>   
            <b-btn size="sm" class="ml-2" v-if="trainingModuleUpdated.length > 1" v-for="btn in trainingModuleUpdated" :disabled="showAll" :variant="showGroup == btn.id ? btn.groupVariant : 'outline-' + btn.groupVariant" @click="showGroup = btn.id" :key="btn.id">{{ btn.btnName }}</b-btn>
            <b-form-checkbox v-if="trainingModuleUpdated.length > 1 && edit" v-model="showAll" :value="true" :unchecked-value="false" @change="showAll && !showGroup && trainingModuleUpdated[0] ? showGroup = trainingModuleUpdated[0].id : ''">View All</b-form-checkbox>
            <h5 class="text-danger" v-if="trainingModuleUpdated.length == 0">No Form or Training Info Added to this Module</h5>
            </b-container>
            <b-container class="pt-3"> 
                    <b-card v-for="(group, index) in trainingModuleUpdated" :key="index"
                      :border-variant="group.groupVariant"
                       v-show="showAll == true ? true : showAll == false && showGroup == group.id ? true : false"
                       v-if="group.groupVisibility ? getFieldVisibility(group.groupVisibility) : true"
                       header-tag="header"
                      :header-bg-variant="group.groupVariant"
                      :header-text-variant="group.groupVariant == 'warning' || group.groupVariant == 'default' ? 'dark' : 'white'">
                  <div slot="header"><span v-if="group.id != editGroupId" >{{ group.groupName }}</span>
                  <span class="float-right" v-if="editGroupId != group.id">
                       <b-btn size="sm" :variant="group.groupVariant == 'warning' || group.groupVariant == 'default' ? 'outline-dark' : 'outline-light'" @click="editGroupId = group.id">Edit Group</b-btn>
                        <b-btn size="sm" :variant="group.groupVariant == 'warning' || group.groupVariant == 'default' ? 'outline-dark' : 'outline-light'" @click="addNewGroupField(group.id)" >Add Field</b-btn></span>
                        
                        <b-row v-if="group.id == editGroupId"><b-col>
                          <h6>Group Title Name</h6>
                          <b-form-input type="text" v-model="group.groupName" placeholder="Give The Form Group A Name" /></b-col>
                          <b-col>
                            <h6>Button Label</h6>
                            <b-form-input type="text" v-model="group.btnName" placeholder="Button Name" /></b-col>
                        <b-col>
                          <h6>Group Color Variant</h6>
                          <b-form-select v-model="group.groupVariant" :options="formGroupColorOptions" /></b-col></b-row>
                    <b-row v-if="group.id == editGroupId" class="mt-2">
                    <b-col align="right" >
                          <b-btn   size="sm" class="float-left" variant="outline-dark"  @click="removeGroup(group.id)">Remove</b-btn>
                      <b-btn size="sm" class="float-right" variant="outline-dark" @click="editGroupId = ''">Save</b-btn></b-col></b-row>      
                
                  </div>
                    <formfields v-show="editGroupId != group.id" :group="group" :vmodelHoldDefault="vmodelHold" :formModules="trainingModule" @editField="editModalField($event, group.id)"  @updateObjectValue="updateFormDataHold" />
                     
                    <br><br>
    
                    </b-card>
                   
                  </b-container>
        <b-modal v-if="showModal" v-model="showModal" size="lg" :hide-footer="true" :title="modalObj.label" :no-close-on-backdrop="true" :no-close-on-esc="true" @hide="resetModalInfo"  >
          <formfieldmodal v-if="modalObj" :field="modalObj" :newField="newField" :formData="trainingModule" @saveModalHoldObj="saveModalHoldObj" @saveModalHoldObjKeep="saveModalHoldObj($event, true)" @removeModalHoldObj="deleteModalField($event, modalGroupHold)" />
        
        </b-modal>
        <b-btn @click="consoleLog(formValues)">Form Values</b-btn>
      
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { VueEditor } from 'vue2-editor'
import userSelector from '../../../inputfields/userfilter.vue'
import formfields from './trainingModuleFormBuilderFields.vue'
import formfieldmodal from './trainingModuleFormBuilderFieldsEditModal.vue'
import moment from 'moment'
export default {
  components: {
    userSelector,
    Multiselect,
    VueEditor,
    formfields,
    formfieldmodal,
  },
  props: ['credentialRequirement', 'newUserFormGroup', 'previousForm' ],
  name: 'training-module',
  data () {
    return {
        currentPage: 1,
        showAll: true,
        newGroupName: '',
        newGroupBtnName: '',
        newGroupVariant: 'default',
        edit: true,
        editGroupId: '',
        showGroup: '',
        dataReset: true,
        newField: false,
        deptRoles: ['user', 'supervisor', 'trainingops', 'emsops', 'fireops', 'adminchief'],
        modalObj: '',
        modalGroupHold: '',
        modalUnsavedField: '',
        showModal: false,
      //  trainingModule: [ { "id": "qbxguicma8fCompany Officers and PA's", "groupName": "Training Main Info", "btnName": "Info", "groupVariant": "default", "groupType": "formData", "dataStore": "formData", "groupFields": [ { "objKey": "ucgwz119hwq", "itemType": "review", "type": "html", "label": "", "size": "12", "value": "<p><strong style=\"color: rgb(230, 0, 0);\"><u>Company Officers and PA's:</u></strong></p><p><br></p><p>All Apprentice III firefighters have been assigned a research project for which they are to present what they learn to their crews. Please assist them in anyway you can. These presentations will be a monthly objective for them going forward.</p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\"><u>All Personnel:</u></strong></p><p><br></p><p>Training for the Month of October will be focused on Alarms and Communications. Additional training elements will include a functional fitness drill, documentation review, a recurring Preplan objective, and a NFPA1410 Drill. Officers and Acting Officers who would like to schedule facility training during the month of October should refer to the training calendar for availability prior to submitting requests. The objectives listed in this training assignment are to be met through training developed by the company officer or his/her designated Subject Matter Expert (SME).</p><p><br></p><p><br></p><p><strong><u>DOCUMENTATION:</u></strong></p><p><br></p><p><strong>FIREFIGHTER RESPONSIBILITY:</strong>&nbsp;Each firefighter is responsible for signing off the monthly topic, once all objectives are complete (bottom of this page)</p><p><br></p><p><strong>OFFICER RESPONSIBILITY:</strong>&nbsp;It is the responsibility of the Officer-In-Charge to document the company, facility, and pre-plan training hours in Target Solutions. This can be accomplished by selecting the appropriate hyperlink, found on the bulletin board on your home screen. Any training completed outside of the outlined objectives should be documented as miscellaneous company/facility training and a description of the training provided.</p><p><br></p>" } ] }, { "2": { "objKey": "5k8aa1d26nm", "itemType": "review", "type": "link", "label": "", "size": "6", "value": [ { "title": "DIR112: Back-Up Radio Communications Procedure", "url": "/files/documents/2017-11-06-09-50DIR112.pdf" }, { "title": "DIR156: Smoke Detector Installation and Home Safety Inspection Documentation", "url": "/files/documents/2017-11-06-09-58DIR156.pdf" }, { "title": "DIR233: Reporting a &quot;MAYDAY&quot;", "url": "/files/2017-11/DIR233.pdf" } ] }, "id": "f8bzp4rilg7Objective 1", "groupName": "Objective 1 - Directive Review", "btnName": "Obj-1", "groupVariant": "primary", "groupType": "formData", "dataStore": "formData", "groupFields": [ { "objKey": "bq8ig11debqThe Station Officer will be responsible for ensuring that all assigned personnel have read and understand the directives listed below. ", "itemType": "review", "type": "textarea", "label": "The Station Officer will be responsible for ensuring that all assigned personnel have read and understand the directives listed below. ", "size": "12", "value": "" }, { "objKey": "4xbjgfd2wh4", "itemType": "review", "type": "link", "label": "", "size": "6", "value": [ { "title": "DIR216: Fire Alarm Response", "url": "/files/documents/2017-11-06-10-03DIR216.pdf" }, { "title": "DIR206: High-Rise Structure Fire", "url": "/files/documents/2017-11-06-10-02DIR206.pdf" }, { "title": "DIR110: Standard Radio Communications", "url": "/files/documents/2017-11-06-09-50DIR110.pdf" } ] }, { "objKey": "5k8aa1d26nm", "itemType": "review", "type": "link", "label": "", "size": "6", "value": [ { "title": "DIR112: Back-Up Radio Communications Procedure", "url": "/files/documents/2017-11-06-09-50DIR112.pdf" }, { "title": "DIR156: Smoke Detector Installation and Home Safety Inspection Documentation", "url": "/files/documents/2017-11-06-09-58DIR156.pdf" }, { "title": "DIR233: Reporting a &quot;MAYDAY&quot;", "url": "/files/2017-11/DIR233.pdf" } ] } ] }, { "2": { "objKey": "kallfmlvtb", "itemType": "review", "type": "video", "label": "", "size": "12", "value": [ "https://www.youtube.com/watch?v=GMLHU0515gY&t=13s" ] }, "id": "hfisk27vxkObjective 2 - Functional Fitness Drill", "groupName": "Objective 2 - Functional Fitness Drill", "btnName": "Obj-2", "groupVariant": "success", "groupType": "formData", "dataStore": "formData", "groupFields": [ { "objKey": "647gpcsvkv4The company officer is responsible for ensuring that all assigned firefighters demonstrate each of the \"functional fitness\" tasks included in the below listed video and training plan. This simple functional fitness drill enables firefighters to demonstrate skills proficiency of donning PPE/SCBA, deploying a ground ladder, and ascending the ladder safely. The intent is to raise awareness of the physical conditioning necessary to perform safely and effectively on the fireground while developing skills proficiency of fundamental firefighting skills. A video has been provided as a visual reference for each segment of the drill.The below Functional Fitness Training Plan should be used as a reference for setting up the drill.", "itemType": "review", "type": "textarea", "label": "The company officer is responsible for ensuring that all assigned firefighters demonstrate each of the \"functional fitness\" tasks included in the below listed video and training plan. This simple functional fitness drill enables firefighters to demonstrate skills proficiency of donning PPE/SCBA, deploying a ground ladder, and ascending the ladder safely. The intent is to raise awareness of the physical conditioning necessary to perform safely and effectively on the fireground while developing skills proficiency of fundamental firefighting skills. A video has been provided as a visual reference for each segment of the drill.The below Functional Fitness Training Plan should be used as a reference for setting up the drill.", "size": "12", "value": "" }, { "objKey": "mqkmrqz5e6h", "itemType": "review", "type": "link", "label": "", "size": "12", "value": [ { "title": "TDR-101: Training Drill Reference", "url": "files/documents/CBA2018/2018-06-14/3c92acf74902acf7490d2fdd1637f1f0ed917542-Sample PDF documents.pdf" } ] }, { "objKey": "kallfmlvtb", "itemType": "review", "type": "video", "label": "", "size": "12", "value": [ "https://www.youtube.com/watch?v=GMLHU0515gY&t=13s" ] } ] }, { "id": "x4m3zf2jrafObjective 3 - Conduct and Complete a Pre-plan", "groupName": "Objective 3 - Conduct and Complete a Pre-plan", "btnName": "Obj-3", "groupVariant": "warning", "groupType": "formData", "dataStore": "formData", "groupFields": [ { "objKey": "5jhs71xirx", "itemType": "review", "type": "html", "label": "", "size": "12", "value": "<p><span style=\"color: rgb(68, 68, 68);\">Per our ISO requirements, all personnel are responsible for completing 12 hours of preplans annually. There will be a recursive segment each month dedicated to ensuring the completion of this requirement. The company officer will be responsible for ensuring that each of their assigned firefighters assists with the completion of a pre-plan.</span></p><p><br></p><p><br></p>" }, { "objKey": "2xn748k2hoo", "itemType": "review", "type": "link", "label": "", "size": "12", "value": [ { "title": "DIR230: Pre-Fire Plans", "url": "/files/documents/2017-11-06-10-05DIR230.pdf" }, { "title": "FORM405: Pre-Plan Form", "url": "/files/2017-11/Form_405.pdf" } ] } ] }, { "id": "6beicn5uelqObjective 4 - NFPA 1410 Evolution 1 (Water Supply)", "groupName": "Objective 4 - NFPA 1410 Evolution 1 (Water Supply)", "btnName": "Obj-4", "groupVariant": "info", "groupType": "formData", "dataStore": "formData", "groupFields": [ { "objKey": "o8non7yrj5s", "itemType": "review", "type": "html", "label": "", "size": "12", "value": "<p><strong style=\"color: rgb(68, 68, 68);\">&nbsp;The Company Officer will be responsible for ensuring that all assigned personnel have participated in the below listed drill.</strong></p>" }, { "objKey": "wxtd0v26s6", "itemType": "review", "type": "link", "label": "", "size": "12", "value": [ { "title": "12-I-2FS: Make a Soft Sleeve Hydrant Connection", "url": "/files/documents/2017-12-19-16-3312-I-2FS.pdf" } ] } ] }, { "id": "qdvurqb51poObjective 5 - Fire Alarm Control Panel Orientation", "groupName": "Objective 5 - Fire Alarm Control Panel Orientation", "btnName": "Obj-5", "groupVariant": "danger", "groupType": "formData", "dataStore": "formData", "groupFields": [ { "objKey": "t4bqrklxhm", "itemType": "review", "type": "html", "label": "", "size": "12", "value": "<p><strong>Fire Alarm Control Panel (FACP) Orientation</strong></p><p><br></p><p><span style=\"color: rgb(68, 68, 68);\">The Station Officer shall (with the owner/managers permission) take assigned personnel to two buildings in their response area and demonstrate how to; read the FACP, silence an alarm, take an alarm out-of-service, and demonstrate the proper procedure when responding to a fire alarm.</span></p>" } ] } ],
        trainingModule: [],
        trainingModuleSubmissionRequirements: [

       ],
       formGroupColorOptions: [
        { value: "info", text: "Teal" },
        { value: "primary", text: "Blue" },
        { value: "success", text: "Green" },
        { value: "danger", text: "Red" },
        { value: "warning", text: "Yellow" },
        { value: "secondary", text: "Grey" },
        { value: "default", text: "Default" }
      ],
      formValues: {

      },
      vmodelHold: {

      },
      setGroupUsersForTraining: [],
      searchData: '',
    }
  },
  created(){
    if(!this.previousForm){
   this.buildFormData(this.trainingModule)
    } else {
      this.trainingModule = this.previousForm.trainingModuleFormData
      this.buildFormData(this.previousForm.trainingModuleFormData)
    }
  },
  computed: {
        ...mapState([
          'getSessionData',
          'apparatusData',
          'stationsData',
          'userData',
          'deptContactData'
        ]),
        trainingModuleUpdated(){
          this.$emit('updateFormInformation',  this.trainingModule)
          return this.trainingModule
        },

  },
  mounted(){

  },
  watch: {
    trainingModuleUpdated(data){
     // this.$emit('updateFormInformation', data)
    }
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    buildNewFormGroup(){
      var groupid = Math.random().toString(36).substr(2, 15)
      var id = groupid + this.newGroupName
      var newObj =               
              {id: id,
              groupName: this.newGroupName,
              btnName: this.newGroupBtnName,
              groupVariant: this.newGroupVariant,
              groupType: 'formData',
              dataStore: 'formData',
              groupFields: []
      }
      this.trainingModule.push(newObj)
      this.newGroupName = ''
        this.newGroupBtnName = ''
        this.newGroupVariant = 'default'
      this.$emit('closeAddNewGroup')
    },
    saveModalHoldObj(newData, keep){
      this.dataReset = false
       var obj = this.trainingModule.find(p => p.id == this.modalGroupHold)
       if(obj){
         var index = obj.groupFields.map(p => p.objKey).indexOf(newData.objKey)
         if(index != -1){
           obj[index] = newData
          if(!keep){
          this.showModal = false
          this.newField = false
          this.modalGroupHold = ''
          this.modalObj = ''
          }
         } else if(newData.objKey == 'new'){
           var objkeyhod = Math.random().toString(36).substr(2, 15)
           var id = objkeyhod + newData.label
           newData.objKey = id
           obj.groupFields.push(newData)
           if(!keep){
           this.showModal = false
           this.newField = false
           this.modalGroupHold = ''
           this.modalObj = ''
           } else {
              this.newField = false
              this.modalObj = newData
           }
          } else {
                   this.showModal = false
                    this.newField = false
          this.modalGroupHold = ''
          this.modalObj = ''
         }
       } 
          else {
          this.showModal = false
          this.newField = false
          this.modalGroupHold = ''
          this.modalObj = ''
       }

      this.buildFormData(this.trainingModule)
      this.$emit('updateFormInformation',  this.trainingModule)
      this.$nextTick(function(){
        this.dataReset = true
      })
    },
    resetModalInfo(){
                       this.showModal = false
                  this.newField = false
          this.modalGroupHold = ''
          this.modalObj = ''
    },
    updateHoldModalObj(data){
      this.modalUnsavedField = data
    },
    addNewGroupField(groupid){
      this.modalGroupHold = groupid
      this.newField = true
      this.modalObj = true
      this.showModal = !this.showModal
    },
    editModalField(field, group){
      var obj = this.trainingModule.find(p => p.id == group)
      if(obj){
        var fieldObj = obj.groupFields.find(p => p.objKey == field)
        if(fieldObj){
          this.modalGroupHold = group
          this.modalObj = fieldObj
          this.showModal = !this.showModal
        }
      }

    },
    removeGroup(group){
      var result = confirm('Are You Sure You Want to Delete this Group? No Going Back!')
      if (result) {
      var index = this.trainingModule.map(p => p.id).indexOf(group)
      this.trainingModule.splice(index, 1)
      }
    },
    deleteModalField(field, group){
       var obj = this.trainingModule.find(p => p.id == group)
       if(obj){
         var index = obj.groupFields.map(p => p.objKey).indexOf(field)
         if(index != -1){
           obj.groupFields.splice(index, 1)
       }
       }
       this.resetModalInfo()
    },
    getFieldVisibility(fn){
      var booleanhold = true
      for(var i in fn){
        if(fn[i].type == 'isOneOf'){
          var index = fn[i].values.indexOf(this.vmodelHold[fn[i].variable])
          if(index == -1){
            booleanhold = false
          }
        } 
      }
      return booleanhold
    },
  updateFormDataHold(data){
        var objHold = data.objKey
        delete data.objKey
        this.formValues[objHold] = data
        console.log(data)
    },
    updateFormData(obj, group){
      var value = this.vmodelHold[obj.objKey]
      var data = this.trainingModule
      var indexG = data.map(p => p.id).indexOf(group.id)
      if(indexG != -1){
      var group = data[indexG].groupFields.find(p => p.objKey == obj.objKey)
        group['value'] = value
      //  data[indexG][indexF] = form
        
      
      }

    },
    buildFormData(data){
      var obj = {}
      var vmodelHold = {}
/*      for(var i in data){
        var input = data[i].groupFields
         if(!data[i].dataStore){
        for(var p in input){
          if(input[p].saveData){
            var value = input[p].itemType == 'array' ? [] : input[p].itemType == 'obj' ? {} : ''
            obj[input[p].objKey] = value
            vmodelHold[input[p].objKey] = value
          }
          }
        } else {
          var newObj = {}
          for(var p in input){
             if(input[p].saveData){
              var value = input[p].itemType == 'array' ? [] : input[p].itemType == 'obj' ? {} : ''
              newObj[input[p].objKey] = value
               vmodelHold[input[p].objKey] = value
             }
          }
          obj[data[i].dataStore] = newObj
        }
      } */
      for(var i in data){
        var fields = data[i].groupFields

        for(var f in fields){
          if(fields[f].itemType == 'form')
          var value = ''
          if(fields[f].type == 'select'){
            var obj = fields[f].selectOptions.find(p => p.default == true)
            if(obj){
              value = obj.value
                this.formValues[fields[f].objKey] = {groupid: data[i].id, value: value}
            }
          }
          if(fields[f].type == 'checkbox'){
            var obj = fields[f].selectOptions.filter(p => p.default == true)
            if(obj){
              value = obj.map(p => p.value)
                this.formValues[fields[f].objKey] = {groupid: data[i].id, value: value}
            }
          }
          if(fields[f].type == 'boolean'){
              value = fields[f].value
                this.formValues[fields[f].objKey] = {groupid: data[i].id, value: value}
            
          }
          if(fields[f].type == 'upload'){
            value = []
          }
          if(fields[f].type == 'selectmulti'){
            var obj = fields[f].selectOptions.filter(p => p.default == true)
            if(obj){
              value = obj
                var array = []
                var arrayStore = []
                for(var v in value){
                    array.push(value[v].value)
                } 
                for(var v in value){
                  arrayStore.push(value[v].text)
                }
                this.formValues[fields[f].objKey] = {groupid: data[i].id, value: arrayStore, searchvalue: array}
            } else {
              value = []
            }
          }
          if(fields[f].type == 'date' || fields[f].type == 'time' || fields[f].type == 'datetime'){
            value = {'date': '', 'time': ''}
          }
          vmodelHold[fields[f].objKey] = value
        }
      }

      this.vmodelHold = vmodelHold
    //  this.formValues = vmodelHold
    },

    submitTrainingModule(data){
      this.$emit('updateFormInformation', data)
  },

}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.table th {
  text-align: center !important;
}
</style>
<style slot-scoped>
.requirement-error{
  border: 1px solid red;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.bootstrapMobile {
  display: none;
}
.inlineBlock {
  display: inline-block;
}
h1, h2 {
  font-weight: normal;
}
@media screen and (max-width: 768px) {
  .bootstrapTable {
    display: none;
  }
  .bootstrapMobile {
    display: block;
  }
}
</style>
